<div class="products-main  content-web-section">
  <div class="col-lg-12 row ">
    <div class="col-lg-12 row tabs-group">
      <div class="tab-container-1 ">
        <div class="col-lg-12 col-md-12 row" role="tablist" aria-label="Fund categories">
          <div class="col-lg-1 col-md-1 col-xs-12"></div>
          <!-- <div class="col-lg-2 col-md-2 col-xs-12 tab-set cursor-pointer radius-left text-center" [ngClass]="{'active-tab':activeTab==='all'}"
          (click)="setActive('all')">
            All Funds ({{fundsData.length}})
            <span class="tab-seperator"></span>
          </div> -->
          <div
        id="tab-all"
        class="col-lg-2 col-md-2 col-xs-12 tab-set cursor-pointer radius-left text-center"
        [ngClass]="{'active-tab': activeTab === 'all'}"
        role="tab"
        aria-controls="panel-all"
        [attr.aria-selected]="activeTab === 'all'"
        [attr.tabindex]="activeTab === 'all' ? 0 : -1"
        (click)="setActive('all')"
        (keydown.enter)="setActive('all')"
        (keydown.space)="setActive('all'); $event.preventDefault()"
        (keydown.arrowright)="moveToNextTab()"
        (keydown.arrowleft)="moveToPreviousTab()"
        (keydown.home)="setActive('all')"
        (keydown.end)="setActive('other')">

        All Funds ({{fundsData.length}})
        <span class="tab-seperator"></span>
      </div>
          <!-- <div class="col-lg-2 col-md-2 col-xs-12 tab-set cursor-pointer text-center" [ngClass]="{'active-tab':activeTab==='equity'}"
          (click)="setActive('equity')">
            Equity Funds ({{equityCount}})
            <span class="tab-seperator"></span>
          </div> -->
         <div
        id="tab-equity"
        class="col-lg-2 col-md-2 col-xs-12 tab-set cursor-pointer text-center"
        [ngClass]="{'active-tab': activeTab === 'equity'}"
        role="tab"
        aria-controls="panel-equity"
        [attr.aria-selected]="activeTab === 'equity'"
        [attr.tabindex]="activeTab === 'equity' ? 0 : -1"
        (click)="setActive('equity')"
        (keydown.enter)="setActive('equity')"
        (keydown.space)="setActive('equity'); $event.preventDefault()"
        (keydown.arrowright)="moveToNextTab()"
        (keydown.arrowleft)="moveToPreviousTab()">

            Equity Funds ({{equityCount}})
            <span class="tab-seperator"></span>
          </div>
          <!-- <div class="col-lg-2 col-md-2 col-xs-12 tab-set cursor-pointer text-center" [ngClass]="{'active-tab':activeTab==='debt'}" (click)="setActive('debt')">
            Debt Funds ({{debtCount}})
            <span class="tab-seperator"></span>
          </div> -->
          <div
          id="tab-debt"
          class="col-lg-2 col-md-2 col-xs-12 tab-set cursor-pointer text-center"
          [ngClass]="{'active-tab': activeTab === 'debt'}"
          role="tab"
          aria-controls="panel-debt"
          [attr.aria-selected]="activeTab === 'debt'"
          [attr.tabindex]="activeTab === 'debt' ? 0 : -1"
          (click)="setActive('debt')"
          (keydown.enter)="setActive('debt')"
          (keydown.space)="setActive('debt'); $event.preventDefault()"
          (keydown.arrowright)="moveToNextTab()"
          (keydown.arrowleft)="moveToPreviousTab()">

          Debt Funds ({{debtCount}})
          <span class="tab-seperator"></span>
        </div>
          <!-- <div class="col-lg-2 col-md-2 col-xs-12 tab-set cursor-pointer text-center" [ngClass]="{'active-tab':activeTab==='hybrid'}"
          (click)="setActive('hybrid')">
            Hybrid Funds ({{hyBridCount}})
            <span class="tab-seperator"></span>
          </div> -->
          <div
          id="tab-hybrid"
          class="col-lg-2 col-md-2 col-xs-12 tab-set cursor-pointer text-center"
          [ngClass]="{'active-tab': activeTab === 'hybrid'}"
          role="tab"
          aria-controls="panel-hybrid"
          [attr.aria-selected]="activeTab === 'hybrid'"
          [attr.tabindex]="activeTab === 'hybrid' ? 0 : -1"
          (click)="setActive('hybrid')"
          (keydown.enter)="setActive('hybrid')"
          (keydown.space)="setActive('hybrid'); $event.preventDefault()"
          (keydown.arrowright)="moveToNextTab()"
          (keydown.arrowleft)="moveToPreviousTab()">

          Hybrid Funds ({{hyBridCount}})
          <span class="tab-seperator"></span>
        </div>
          <!-- <div class="col-lg-2 col-md-2 col-xs-12 tab-set cursor-pointer radius-right text-center" [ngClass]="{'active-tab':activeTab==='other'}"
          (click)="setActive('other')">
            Others ({{otherCount}})
          </div> -->
          <div
          id="tab-other"
          class="col-lg-2 col-md-2 col-xs-12 tab-set cursor-pointer radius-right text-center"
          [ngClass]="{'active-tab': activeTab === 'other'}"
          role="tab"
          aria-controls="panel-other"
          [attr.aria-selected]="activeTab === 'other'"
          [attr.tabindex]="activeTab === 'other' ? 0 : -1"
          (click)="setActive('other')"
          (keydown.enter)="setActive('other')"
          (keydown.space)="setActive('other'); $event.preventDefault()"
          (keydown.arrowright)="moveToNextTab()"
          (keydown.arrowleft)="moveToPreviousTab()">

          Others ({{otherCount}})
        </div>
          <!-- <div class="col-lg-1 col-md-1 col-xs-12"></div> -->
        </div>

      </div>
      <div class="tab-container-2">
        <span class="right-content">
          <!-- <span class="select-label">Scheme Plan : </span>
          <select class="select-data" (change)="setPlan($any($event.target).value)">
            <option *ngFor="let item of schemeType" [value]="item.value">{{item.displayName}}</option>
          </select>
        </span> -->
        <label for="schemePlan" class="select-label">
        Scheme Plan :
      </label>

      <select
          id="schemePlan"
          class="select-data"
          (change)="setPlan($any($event.target).value)">

          <option *ngFor="let item of schemeType"
                  [value]="item.value">
              {{item.displayName}}
          </option>

      </select>
        </span>
          </div>
          <div
          class="sr-only"
          role="status">
          {{ liveMessage }}
        </div>

    <div class="tab-content py-3 px-3 px-sm-0 col-lg-12 row" >
      <!-- <div class="col-lg-12 row"> -->
        <div class="col-lg-3 ">
         <div class="col-lg-12 filters-section">
  <img src="assets/icons/icon_filter.png" alt="">
  <h2 class="filters-header">Filters</h2>
  <hr role="presentation" aria-hidden="true">

  <ng-container *ngFor="let item of filtersData; let lastMain = last">

    <fieldset class="filter-group">
     <legend> <h3 class="filter-sub-section mb-2"> {{ item.heading }} </h3> </legend>

      <div *ngFor="let subItem of item.datas; let i = index">
        <input
          type="checkbox"
          class="filter-check-box cursor-pointer"
          [id]="item.name + '-' + i"
          [value]="subItem.value"
          (change)="applyFilters($event,item.name,subItem.value)">

        <label
          class="filter-check-box-text"
          [for]="item.name + '-' + i">
          {{ subItem.displayName }}
        </label>
      </div>
    </fieldset>

    <hr role="presentation" aria-hidden="true" *ngIf="!lastMain">

  </ng-container>
</div>
          </div>
        
        <div class="col-lg-9">
          <div *ngIf="activeTab==='all'" id="panel-all" role="tabpanel" aria-labelledby="tab-all">
            <div class="col-lg-12 row">
              <div class="col-lg-6  mobile-padding-top " *ngFor="let item of fundsData;let i=index">
                <div class="individual-funds">
                  <div class="top-right-corner"
                  [ngClass]="{'top-right-corner-l': item.risk.trim()==='Low', 'top-right-corner-mh': item.risk.trim()==='Moderate' || item.risk.trim()==='Moderately High'  || item.risk.trim()==='Moderately Low' || item.risk.trim()==='Low to Moderate','top-right-corner-m': item.risk.trim()==='High' || item.risk.trim()==='Very High'}">
                    <span class="risk-text"> {{item.risk}} Risk </span>
                  </div>
                  <span class="fund-heading">{{item.fundType}}</span>
                  <span class="growth-section">  {{splitString(item.plan)}}</span>
                  <br>
                  <h2 class="fund-heading-2" [id]="'fund-' + i">{{item.scheme}} </h2><br>
                  <div class="fund-text">{{item.description}}</div><br>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <span class="fund-date" *ngIf="item.currentDate"> As on {{commonDataService.customDate(item.currentDate)}} </span><br>
                  <span class="fund-date" *ngIf="!item.currentDate"> NA </span><br>
                  <span class="date-text">NAV &nbsp; &#8377;  {{item.nav  }}</span> &nbsp;
                   <!-- <img src="assets/icons/up_arrow.png" class="img-width" *ngIf="item.navPercent>=0">
                   <img src="assets/icons/down_arrow.png" class="img-width" *ngIf="item.navPercent<0"> -->
                   <img
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRdVkehRZhOHpHmOJvx_iTmS-1JUBFYSZVEc6d4tzG6bg&s"
                        class="img-width"
                        *ngIf="item.navPercent>=0"
                        [attr.alt]="'NAV increased by ' + (item.navPercent | number:'1.2-2') + ' percent'">

                        <img
                        src="assets/icons/down_arrow.png"
                        class="img-width"
                        *ngIf="item.navPercent<0"
                        [attr.alt]="'NAV decreased by ' + ((item.navPercent * -1) | number:'1.2-2') + ' percent'">

                  <span [ngClass]="{'date-vals': item.navPercent>=0,'date-vals-low': item.navPercent<0}">( {{item.navPercent | number : '1.2-2'}}% )</span>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <h3 class="caption-cag">CAGR</h3><br><br>
                  <div class="d-flex">
                    <div class="years-data">
                      <span *ngIf="item?.cagrYear[0]?.one"> 
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].one<0,  'data-green': item.cagrYear[0].one>=0}" > 
                          <ng-template [ngIf]="item.cagrYear[0].one === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].one !== 'NA'">
                            <span> {{item.cagrYear[0].one}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.one">-</span>
                      <br>
                        <span class="years-share-text">(Last 1 Year)</span>
                    </div>
                  
                    <div class="years-data">
                      &nbsp;   <span *ngIf="item?.cagrYear[0]?.three">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].three === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].three !== 'NA'">
                            <span> {{item.cagrYear[0].three}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.three">-</span>
                      <br>
                      &nbsp;<span class="years-share-text"> (Last 3 Years)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;    <span *ngIf="item?.cagrYear[0]?.five">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].five === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].five !== 'NA'">
                            <span> {{item.cagrYear[0].five}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.five">-</span>
                      <br>
                      &nbsp; <span class="years-share-text"> (Last 5 Years)</span>
                    </div>
                </div>
                  <span class="seperator"></span>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <!-- <br> -->
                  <div class="align-h">
                    <div class="stretch">
                    <button type="button" (click)="investOnline()" class="common-submit-button-banner cursor-pointer" class="common-submit-button-banner cursor-pointer" [id]="'invest-' + i" [attr.aria-labelledby]="'invest-' + i + ' fund-' + i">Invest Now</button>
                   </div>
                   <div class="margin-right-15">
                    <button type="button" id="invest-now" (click)="viewDetails(item.scheme, item)" class="common-submit-button-banner cursor-pointer btn-color-black margin-left-15" [id]="'explore-' + i" [attr.aria-labelledby]="'explore-' + i + ' fund-' + i">Explore</button>
                  </div>
                  </div>
                  <br><br>
                </div>
              </div>

            </div>
            <div class="no-fund text-center" *ngIf="!fundsData || fundsData.length<=0">No Funds Available</div>
          </div>
          <div *ngIf="activeTab==='equity'" id="panel-equity" role="tabpanel" aria-labelledby="tab-equity">
            <div class="col-lg-12 row">
              <ng-container  *ngFor="let item of fundsData;let i=index">
              <div class="col-lg-6  mobile-padding-top " *ngIf="item.fundType==='Equity'">
                <div class="col-lg-12 individual-funds">
                  <div class="top-right-corner"
                  [ngClass]="{'top-right-corner-l': item.risk.trim()==='Low', 'top-right-corner-mh': item.risk.trim()==='Moderate' || item.risk.trim()==='Moderately High'  || item.risk.trim()==='Moderately Low' || item.risk.trim()==='Low to Moderate','top-right-corner-m': item.risk.trim()==='High' || item.risk.trim()==='Very High'}">
                    <span class="risk-text">{{item.risk}} Risk</span>
                  </div>
                  <span class="fund-heading">{{item.fundType}}</span>
                  <span class="growth-section">  {{splitString(item.plan)}}</span>
                  <br>
                  <h2 class="fund-heading-2" [id]="'fund-' + i">{{item.scheme}}</h2><br>
                  <div class="fund-text">{{item.description}}</div><br>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <span class="fund-date" *ngIf="item.currentDate"> As on {{commonDataService.customDate(item.currentDate)}} </span><br>
                  <span class="fund-date" *ngIf="!item.currentDate"> NA </span><br>
                  <span class="date-text">NAV &nbsp; &#8377; {{item.nav }}</span> &nbsp;
                   <!-- <img src="assets/icons/up_arrow.png" class="img-width" *ngIf="item.navPercent>=0">
                   <img src="assets/icons/down_arrow.png" class="img-width"  *ngIf="item.navPercent<0"> -->
                   <img
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRdVkehRZhOHpHmOJvx_iTmS-1JUBFYSZVEc6d4tzG6bg&s"
                        class="img-width"
                        *ngIf="item.navPercent>=0"
                        [attr.alt]="'NAV increased by ' + (item.navPercent | number:'1.2-2') + ' percent'">

                        <img
                        src="assets/icons/down_arrow.png"
                        class="img-width"
                        *ngIf="item.navPercent<0"
                        [attr.alt]="'NAV decreased by ' + ((item.navPercent * -1) | number:'1.2-2') + ' percent'">

                  <span [ngClass]="{'date-vals': item.navPercent>=0,'date-vals-low': item.navPercent<0}">( {{item.navPercent | number : '1.2-2'}}% )</span>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <h3 class="caption-cag">CAGR</h3><br><br>
                  <div class="d-flex">
                    <div class="years-data">
                      <span *ngIf="item?.cagrYear[0]?.one"> 
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].one<0,  'data-green': item.cagrYear[0].one>=0}" > 
                        <ng-template [ngIf]="item?.cagrYear[0]?.one === 'NA'">
                            <span>NA</span>
                        </ng-template>
                        <ng-template [ngIf]="item?.cagrYear[0]?.one !== 'NA'">
                          <span>{{item.cagrYear[0].one}}%</span>
                        </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.one">-</span>
                      <br>
                        <span class="years-share-text"> ( Year)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;   <span *ngIf="item?.cagrYear[0]?.three">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item?.cagrYear[0]?.three === 'NA'">
                            <span>NA</span>
                        </ng-template>
                        <ng-template [ngIf]="item?.cagrYear[0]?.three !== 'NA'">
                          <span>{{item.cagrYear[0].three}}%</span>
                        </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.three">-</span>
                      <br>
                      &nbsp;<span class="years-share-text"> (Last 3 Years)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;    <span *ngIf="item?.cagrYear[0]?.five">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].five<0,  'data-green': item.cagrYear[0].five>=0}"> 
                          <ng-template [ngIf]="item?.cagrYear[0]?.five === 'NA'">
                            <span>NA</span>
                        </ng-template>
                        <ng-template [ngIf]="item?.cagrYear[0]?.five !== 'NA'">
                          <span>{{item.cagrYear[0].five}}%</span>
                        </ng-template>
                        </span>
                        </span>
                      <span *ngIf="!item?.cagrYear[0]?.five">-</span>
                      <br>
                      &nbsp; <span class="years-share-text"> (Last 5 Years)</span>
                    </div>
                </div>
                  <span class="seperator"></span>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <!-- <br> -->
                  <div class="align-h">
                    <div class="stretch">
                    <button type="button" (click)="investOnline()" class="common-submit-button-banner cursor-pointer" [id]="'invest-' + i" [attr.aria-labelledby]="'invest-' + i + ' fund-' + i">Invest Now</button>
                   </div>
                   <div>
                    <button type="button" id="invest-now" (click)="viewDetails(item.scheme, item)" class="common-submit-button-banner cursor-pointer btn-color-black margin-left-15" [id]="'explore-' + i" [attr.aria-labelledby]="'explore-' + i + ' fund-' + i">Explore</button>
                  </div>
                  </div>
                  <br><br>
                </div>
              </div>
            </ng-container>

            </div>
            <div class="no-fund text-center" *ngIf="equityCount<=0">No Funds Available</div>
          </div>
          <div *ngIf="activeTab==='debt'" id="panel-debt" role="tabpanel" aria-labelledby="tab-debt">
            <div class="col-lg-12 row">
              <ng-container  *ngFor="let item of fundsData;let i=index">
              <div class="col-lg-6  mobile-padding-top " *ngIf="item.fundType==='Debt'">
                <div class="col-lg-12 individual-funds">
                  <div class="top-right-corner"
                  [ngClass]="{'top-right-corner-l': item.risk.trim()==='Low', 'top-right-corner-mh': item.risk.trim()==='Moderate' || item.risk.trim()==='Moderately High'  || item.risk.trim()==='Moderately Low' || item.risk.trim()==='Low to Moderate','top-right-corner-m': item.risk.trim()==='High' || item.risk.trim()==='Very High'}">
                    <span class="risk-text">{{item.risk}} Risk</span>
                  </div>
                  <span class="fund-heading">{{item.fundType}}</span>
                  <span class="growth-section">  {{splitString(item.plan)}}</span>
                  <br>
                  <h2 class="fund-heading-2" [id]="'fund-' + i">{{item.scheme}}</h2><br>
                  <div class="fund-text">{{item.description}}</div><br>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <span class="fund-date" *ngIf="item.currentDate"> As on {{commonDataService.customDate(item.currentDate)}} </span><br>
                  <span class="fund-date" *ngIf="!item.currentDate"> NA </span><br>
                  <span class="date-text">NAV &nbsp; &#8377;  {{item.nav}}</span> &nbsp;
                   <!-- <img src="assets/icons/up_arrow.png" class="img-width" *ngIf="item.navPercent>=0">
                   <img src="assets/icons/down_arrow.png" class="img-width" *ngIf="item.navPercent<0"> -->
                   <img
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRdVkehRZhOHpHmOJvx_iTmS-1JUBFYSZVEc6d4tzG6bg&s"
                        class="img-width"
                        *ngIf="item.navPercent>=0"
                        [attr.alt]="'NAV increased by ' + (item.navPercent | number:'1.2-2') + ' percent'">

                        <img
                        src="assets/icons/down_arrow.png"
                        class="img-width"
                        *ngIf="item.navPercent<0"
                        [attr.alt]="'NAV decreased by ' + ((item.navPercent * -1) | number:'1.2-2') + ' percent'">

                  <span [ngClass]="{'date-vals': item.navPercent>=0,'date-vals-low': item.navPercent<0}">( {{item.navPercent | number : '1.2-2'}}% )</span>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <h3 class="caption-cag">CAGR</h3><br><br>
                  <div class="d-flex">
                    <div class="years-data">
                      <span *ngIf="item?.cagrYear[0]?.one"> 
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].one<0,  'data-green': item.cagrYear[0].one>=0}" > 
                          <ng-template [ngIf]="item.cagrYear[0].one === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].one !== 'NA'">
                            <span>{{item.cagrYear[0].one}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.one">-</span>
                      <br>
                        <span class="years-share-text"> (Last 1 Year)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;   <span *ngIf="item?.cagrYear[0]?.three">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].three === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].three !== 'NA'">
                            <span>{{item.cagrYear[0].one}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.three">-</span>
                      <br>
                      &nbsp;<span class="years-share-text"> (Last 3 Years)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;    <span *ngIf="item?.cagrYear[0]?.five">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].five === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].five !== 'NA'">
                            <span>{{item.cagrYear[0].one}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.five">-</span>
                      <br>
                      &nbsp; <span class="years-share-text"> (Last 5 Years)</span>
                    </div>
                </div>
                  <span class="seperator"></span>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <!-- <br> -->
                  <div class="align-h">
                    <div class="stretch">
                    <button type="button" (click)="investOnline()" class="common-submit-button-banner cursor-pointer" [id]="'invest-' + i" [attr.aria-labelledby]="'invest-' + i + ' fund-' + i">Invest Now</button>
                   </div>
                   <div>
                    <button type="button" id="invest-now" (click)="viewDetails(item.scheme, item)" class="common-submit-button-banner cursor-pointer btn-color-black margin-left-15" [id]="'explore-' + i" [attr.aria-labelledby]="'explore-' + i + ' fund-' + i">Explore</button>
                  </div>
                  </div>
                  <br><br>
                </div>
              </div>
            </ng-container>

            </div>
            <div class="no-fund text-center" *ngIf="debtCount<=0">No Funds Available</div>
          </div>
          <div *ngIf="activeTab==='hybrid'" id="panel-hybrid" role="tabpanel" aria-labelledby="tab-hybrid">
            <div class="col-lg-12 row">
              <ng-container  *ngFor="let item of fundsData;let i=index">
              <div class="col-lg-6  mobile-padding-top " *ngIf="item.fundType==='Hybrid'">
                <div class="col-lg-12 individual-funds">
                  <div class="top-right-corner"
                  [ngClass]="{'top-right-corner-l': item.risk.trim()==='Low', 'top-right-corner-mh': item.risk.trim()==='Moderate' || item.risk.trim()==='Moderately High'  || item.risk.trim()==='Moderately Low' || item.risk.trim()==='Low to Moderate','top-right-corner-m': item.risk.trim()==='High' || item.risk.trim()==='Very High'}">
                    <span class="risk-text">{{item.risk}} Risk</span>
                  </div>
                  <span class="fund-heading">{{item.fundType}}</span>
                  <span class="growth-section">  {{splitString(item.plan)}}</span>
                  <br>
                  <h2 class="fund-heading-2" [id]="'fund-' + i">{{item.scheme}}</h2><br>
                  <div class="fund-text">{{item.description}}</div><br>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <span class="fund-date" *ngIf="item.currentDate"> As on {{commonDataService.customDate(item.currentDate)}} </span><br>
                  <span class="fund-date" *ngIf="!item.currentDate"> NA </span><br>
                  <span class="date-text">NAV &nbsp; &#8377;  {{item.nav}}</span> &nbsp;
                   <!-- <img src="assets/icons/up_arrow.png" class="img-width" *ngIf="item.navPercent>=0">
                   <img src="assets/icons/down_arrow.png" class="img-width" *ngIf="item.navPercent<0"> -->
                   <img
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRdVkehRZhOHpHmOJvx_iTmS-1JUBFYSZVEc6d4tzG6bg&s"
                        class="img-width"
                        *ngIf="item.navPercent>=0"
                        [attr.alt]="'NAV increased by ' + (item.navPercent | number:'1.2-2') + ' percent'">

                        <img
                        src="assets/icons/down_arrow.png"
                        class="img-width"
                        *ngIf="item.navPercent<0"
                        [attr.alt]="'NAV decreased by ' + ((item.navPercent * -1) | number:'1.2-2') + ' percent'">

                  <span [ngClass]="{'date-vals': item.navPercent>=0,'date-vals-low': item.navPercent<0}">( {{item.navPercent | number : '1.2-2'}}% )</span>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <h3 class="caption-cag">CAGR</h3><br><br>
                  <div class="d-flex">
                    <div class="years-data">
                      <span *ngIf="item?.cagrYear[0]?.one"> 
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].one<0,  'data-green': item.cagrYear[0].one>=0}" > 
                          <ng-template [ngIf]="item.cagrYear[0].one === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].one !== 'NA'">
                            <span>{{item.cagrYear[0].one}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.one">-</span>
                      <br>
                        <span class="years-share-text"> (Last 1 Year)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;   <span *ngIf="item?.cagrYear[0]?.three">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}">
                          <ng-template [ngIf]="item.cagrYear[0].three === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].three !== 'NA'">
                            <span>{{item.cagrYear[0].three}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.three">-</span>
                      <br>
                      &nbsp;<span class="years-share-text"> (Last 3 Years)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;    <span *ngIf="item?.cagrYear[0]?.five">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}">
                          <ng-template [ngIf]="item.cagrYear[0].five === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].five !== 'NA'">
                            <span>{{item.cagrYear[0].five}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.five">-</span>
                      <br>
                      &nbsp; <span class="years-share-text"> (Last 5 Years)</span>
                    </div>
                </div>
                  <span class="seperator"></span>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <!-- <br> -->
                  <div class="align-h">
                    <div class="stretch">
                    <button type="button" (click)="investOnline()" class="common-submit-button-banner cursor-pointer" [id]="'invest-' + i" [attr.aria-labelledby]="'invest-' + i + ' fund-' + i">Invest Now</button>
                   </div>
                   <div>
                    <button type="button" id="invest-now" (click)="viewDetails(item.scheme, item)" class="common-submit-button-banner cursor-pointer btn-color-black margin-left-15" [id]="'explore-' + i" [attr.aria-labelledby]="'explore-' + i + ' fund-' + i">Explore</button>
                  </div>
                  </div>
                  <br><br>
                </div>
              </div>
            </ng-container>

            </div>
            <div class="no-fund text-center" *ngIf="hyBridCount<=0">No Funds Available</div>
          </div>
          <div *ngIf="activeTab==='other'" id="panel-other" role="tabpanel" aria-labelledby="tab-other">
            <div class="col-lg-12 row">
              <ng-container  *ngFor="let item of fundsData;let i=index">
              <div class="col-lg-6  mobile-padding-top " *ngIf="item.fundType!=='Equity' && item.fundType!=='Debt' && item.fundType!=='Hybrid' ">
                <div class="col-lg-12 individual-funds">
                  <div class="top-right-corner"
                  [ngClass]="{'top-right-corner-l': item.risk.trim()==='Low', 'top-right-corner-mh': item.risk.trim()==='Moderate' || item.risk.trim()==='Moderately High'  || item.risk.trim()==='Moderately Low' || item.risk.trim()==='Low to Moderate','top-right-corner-m': item.risk.trim()==='High' || item.risk.trim()==='Very High'}">
                    <span class="risk-text">{{item.risk}} Risk</span>
                  </div>
                  <span class="fund-heading">{{item.fundType}}</span>
                  <span class="growth-section">  {{splitString(item.plan)}}</span>
                  <br>
                  <h2 class="fund-heading-2" [id]="'fund-' + i">{{item.scheme}}</h2><br>
                  <div class="fund-text">{{item.description}}</div><br>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <span class="fund-date" *ngIf="item.currentDate"> As on {{commonDataService.customDate(item.currentDate)}}</span><br>
                  <span class="fund-date" *ngIf="!item.currentDate"> NA </span><br>
                  <span class="date-text">NAV &nbsp; &#8377;  {{item.nav}}</span> &nbsp;
                  <!-- <img src="assets/icons/up_arrow.png" class="img-width" *ngIf="item.navPercent>=0">
                  <img src="assets/icons/down_arrow.png" class="img-width"  *ngIf="item.navPercent<0"> -->
                  <img
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRdVkehRZhOHpHmOJvx_iTmS-1JUBFYSZVEc6d4tzG6bg&s"
                        class="img-width"
                        *ngIf="item.navPercent>=0"
                        [attr.alt]="'NAV increased by ' + (item.navPercent | number:'1.2-2') + ' percent'">

                        <img
                        src="assets/icons/down_arrow.png"
                        class="img-width"
                        *ngIf="item.navPercent<0"
                        [attr.alt]="'NAV decreased by ' + ((item.navPercent * -1) | number:'1.2-2') + ' percent'">

                  <span [ngClass]="{'date-vals': item.navPercent>=0,'date-vals-low': item.navPercent<0}">( {{item.navPercent | number : '1.2-2'}}% )</span>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <h3 class="caption-cag">CAGR</h3><br><br>
                  <div class="d-flex">
                    <div class="years-data">
                      <span *ngIf="item?.cagrYear[0]?.one"> 
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].one<0,  'data-green': item.cagrYear[0].one>=0}" >
                           <ng-template [ngIf]="item.cagrYear[0].one === 'NA'">
                             <span>NA</span>
                           </ng-template>
                           <ng-template [ngIf]="item.cagrYear[0].one !== 'NA'">
                            <span>{{item.cagrYear[0].one}}%</span>
                          </ng-template>
                          </span>
                        </span>
                      <span *ngIf="!item?.cagrYear[0]?.one">-</span>
                      <br>
                        <span class="years-share-text"> (Last 1 Year)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;   <span *ngIf="item?.cagrYear[0]?.three">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].three === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].three !== 'NA'">
                           <span>{{item.cagrYear[0].three}}%</span>
                         </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.three">-</span>
                      <br>
                      &nbsp;<span class="years-share-text"> (Last 3 Years)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;    <span *ngIf="item?.cagrYear[0]?.five"><span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> {{item.cagrYear[0].five}}%</span></span>
                      <span *ngIf="!item?.cagrYear[0]?.five">-</span>
                      <br>
                      &nbsp; <span class="years-share-text"> (Last 5 Years)</span>
                    </div>
                </div>
                  <span class="seperator"></span>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <!-- <br> -->
                  <div class="align-h">
                    <div class="stretch">
                    <button type="button" (click)="investOnline()" class="common-submit-button-banner cursor-pointer" [id]="'invest-' + i" [attr.aria-labelledby]="'invest-' + i + ' fund-' + i">Invest Now</button>
                   </div>
                   <div>
                    <button type="button" id="invest-now" (click)="viewDetails(item.scheme, item)" class="common-submit-button-banner cursor-pointer btn-color-black margin-left-15" [id]="'explore-' + i" [attr.aria-labelledby]="'explore-' + i + ' fund-' + i">Explore</button>
                  </div>
                  </div>
                  <br><br>
                </div>
              </div>
            </ng-container>

            </div>
            <div class="no-fund text-center" *ngIf="otherCount<=0">No Funds Available</div>
          </div>
        </div>
      <!-- </div> -->
    </div>
  </div>
</div>






<div class="products-main products-main-mobile content-mobile-section">
  <div class="col-lg-12 row p-0 mob-content-1">
    <div class="col-lg-12 row ">
    <div class="col-8 p-0 ">
    <!-- <select  class="select-data1" [(ngModel)]="activeTab" >
      <option value="all"> All Funds ({{fundsData.length}})</option>
      <option value="equity">  Equity Funds ({{equityCount}})</option>
      <option value="debt"> Debt Funds ({{debtCount}})</option>
      <option value="hybrid">  Hybrid Funds ({{hyBridCount}})</option>
      <option value="other">  Others ({{otherCount}})</option>
    </select> -->
    <label for="fund-category" class="sr-only">
      Select fund category
    </label>

    <select
      id="fund-category"
      class="select-data1"
      [(ngModel)]="activeTab"
      aria-label="Select fund category">

      <option value="all">All Funds ({{fundsData.length}})</option>
      <option value="equity">Equity Funds ({{equityCount}})</option>
      <option value="debt">Debt Funds ({{debtCount}})</option>
      <option value="hybrid">Hybrid Funds ({{hyBridCount}})</option>
      <option value="other">Others ({{otherCount}})</option>
    </select>
    </div>
    <div class="col-2">
      <img src="assets/icons/icon_filter.png" (click)="setFilterSection(true)" class="m-filter" alt="">
      <span class="filters-header"></span>
    </div>
    <div class="col-2 ">
      <img  (click)="openPopUpScheme()" src="assets/icons/2arrow-t.png" class="scheme-icon-n">
    </div>
  </div>

  <div
  class="sr-only"
  role="status">
  {{ liveMessage }}
</div>

    <div class="tab-content py-3 px-3 px-sm-0 col-lg-12 row" >
        <div class="col-12 p-0" *ngIf="viewFilters">
          <div class="col-lg-12 filters-section">
           <span class="close-filter" (click)="setFilterSection(false)">X</span>
           <h2 class="filters-header"> Filters</h2>
            <hr role="presentation" aria-hidden="true">
         <ng-container *ngFor="let item of filtersData; let lastMain = last">

  <fieldset class="filter-group">

    <legend>
      <h3 class="filter-sub-section mb-2">
        {{ item.heading }}
      </h3>
    </legend>

    <div *ngFor="let subItem of item.datas; let i = index">

      <input
        type="checkbox"
        class="filter-check-box cursor-pointer"
        [id]="'mobile-' + item.name + '-' + i"
        [value]="subItem.value"
        (change)="setMobileFilterOptionsFilters($event, item.name, subItem.value)">

      <label
        class="filter-check-box-text"
        [for]="'mobile-' + item.name + '-' + i">
        {{ subItem.displayName }}
      </label>

    </div>

  </fieldset>

  <hr  role="presentation" aria-hidden="true" *ngIf="!lastMain">

</ng-container>
            <hr role="presentation" aria-hidden="true">
            <a (click)="clearMobileFilters()"class="clear-filters"><u>Clear Filters</u></a>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <button type="button" (click)="getFunds()"class="apply-filters">Apply</button>

          </div>
        </div>
        <div class="col-12 p-0"  *ngIf="!viewFilters">
          <div *ngIf="activeTab==='all'">
            <div class="col-lg-12 row p-0 m-0">
              <div class="col-lg-6  mobile-padding-top p-0" *ngFor="let item of fundsData;let i=index">
                <div class="col-lg-12 individual-funds">
                  <div class="top-right-corner"
                  [ngClass]="{'top-right-corner-l': item.risk.trim()==='Low', 'top-right-corner-mh': item.risk.trim()==='Moderate' || item.risk.trim()==='Moderately High'  || item.risk.trim()==='Moderately Low' || item.risk.trim()==='Low to Moderate','top-right-corner-m': item.risk.trim()==='High' || item.risk.trim()==='Very High'}"> 
                  <span class="risk-text">{{item.risk}} Risk</span>
                  </div>
                  <span class="fund-heading">{{item.fundType}}</span>
                  <span class="growth-section">  {{splitString(item.plan)}}</span>
                  <br>
                  <h2 class="fund-heading-2" [id]="'fund-' + i">{{item.scheme}}</h2><br>
                  <span class="fund-text">{{item.description}}</span><br>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <span class="fund-date" *ngIf="item.currentDate"> As on {{commonDataService.customDate(item.currentDate)}} </span><br>
                  <span class="fund-date" *ngIf="!item.currentDate"> NA </span><br>
                  <span class="date-text">NAV &nbsp; &#8377;   {{item.nav }}</span> &nbsp;
                   <!-- <img src="assets/icons/up_arrow.png" class="img-width" *ngIf="item.navPercent>=0">
                   <img src="assets/icons/down_arrow.png" class="img-width" *ngIf="item.navPercent<0"> -->
                   <img
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRdVkehRZhOHpHmOJvx_iTmS-1JUBFYSZVEc6d4tzG6bg&s"
                      class="img-width"
                      *ngIf="item.navPercent>=0"
                      [attr.alt]="'NAV increased by ' + (item.navPercent | number:'1.2-2') + ' percent'">

                      <img
                      src="assets/icons/down_arrow.png"
                      class="img-width"
                      *ngIf="item.navPercent<0"
                      [attr.alt]="'NAV decreased by ' + ((item.navPercent * -1) | number:'1.2-2') + ' percent'">

                  <span [ngClass]="{'date-vals': item.navPercent>=0,'date-vals-low': item.navPercent<0}">( {{item.navPercent | number : '1.2-2'}}% )</span>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <h3 class="caption-cag">CAGR</h3><br><br>
                  <div class="d-flex">
                    <div class="years-data">
                      <span *ngIf="item?.cagrYear[0]?.one"> 
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].one<0,  'data-green': item.cagrYear[0].one>=0}" > 
                          <ng-template [ngIf]="item.cagrYear[0].one === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].one !== 'NA'">
                            <span> {{item.cagrYear[0].one}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.one">-</span>
                      <br>
                        <span class="years-share-text"> (Last 1 Year)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;   <span *ngIf="item?.cagrYear[0]?.three">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].three === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].three !== 'NA'">
                            <span> {{item.cagrYear[0].three}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.three">-</span>
                      <br>
                      &nbsp;<span class="years-share-text"> (Last 3 Years)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;    <span *ngIf="item?.cagrYear[0]?.five">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].five === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].five !== 'NA'">
                            <span> {{item.cagrYear[0].five}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.five">-</span>
                      <br>
                      &nbsp; <span class="years-share-text"> (Last 5 Years)</span>
                    </div>
                </div>
                  <span class="seperator"></span>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <br>
                  <div class="align-h">
                    <div class="stretch">
                    <button type="button" (click)="investOnline()" class="common-submit-button-banner cursor-pointer" [id]="'invest-' + i" [attr.aria-labelledby]="'invest-' + i + ' fund-' + i">Invest Now</button>
                   </div>
                   <div>
                    <button type="button" id="invest-now" (click)="viewDetails(item.scheme, item)" class="common-submit-button-banner cursor-pointer btn-color-black margin-left-15" [id]="'explore-' + i" [attr.aria-labelledby]="'explore-' + i + ' fund-' + i">Explore</button>
                  </div>
                  </div>
                  <br><br>
                </div>
              </div>

            </div>
            <div class="no-fund text-center" *ngIf="!fundsData || fundsData.length<=0">No Funds Available</div>
          </div>
          <div *ngIf="activeTab==='equity'">
            <div class="col-lg-12 row p-0">
              <ng-container  *ngFor="let item of fundsData;let i=index">
              <div class="col-lg-6 p-0 mobile-padding-top " *ngIf="item.fundType==='Equity'">
                <div class="col-lg-12 individual-funds">
                  <div class="top-right-corner"
                  [ngClass]="{'top-right-corner-l': item.risk.trim()==='Low', 'top-right-corner-mh': item.risk.trim()==='Moderate' || item.risk.trim()==='Moderately High'  || item.risk.trim()==='Moderately Low' || item.risk.trim()==='Low to Moderate','top-right-corner-m': item.risk.trim()==='High' || item.risk.trim()==='Very High'}">
                    <span class="risk-text">{{item.risk}} Risk</span>
                  </div>
                  <span class="fund-heading">{{item.fundType}}</span>
                  <span class="growth-section">  {{splitString(item.plan)}}</span>
                  <br>
                  <h2 class="fund-heading-2" [id]="'fund-' + i">{{item.scheme}}</h2><br>
                  <span class="fund-text">{{item.description}}</span><br>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <span class="fund-date" *ngIf="item.currentDate"> As on {{commonDataService.customDate(item.currentDate)}} </span><br>
                  <span class="fund-date" *ngIf="!item.currentDate"> NA </span><br>
                  <span class="date-text">NAV &nbsp; &#8377;  {{item.nav }}</span> &nbsp;
                   <!-- <img src="assets/icons/up_arrow.png" class="img-width" *ngIf="item.navPercent>=0">
                   <img src="assets/icons/down_arrow.png" class="img-width"  *ngIf="item.navPercent<0"> -->
                   <img
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRdVkehRZhOHpHmOJvx_iTmS-1JUBFYSZVEc6d4tzG6bg&s"
                        class="img-width"
                        *ngIf="item.navPercent>=0"
                        [attr.alt]="'NAV increased by ' + (item.navPercent | number:'1.2-2') + ' percent'">

                        <img
                        src="assets/icons/down_arrow.png"
                        class="img-width"
                        *ngIf="item.navPercent<0"
                        [attr.alt]="'NAV decreased by ' + ((item.navPercent * -1) | number:'1.2-2') + ' percent'">

                  <span [ngClass]="{'date-vals': item.navPercent>=0,'date-vals-low': item.navPercent<0}">( {{item.navPercent | number : '1.2-2'}}% )</span>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <h3 class="caption-cag">CAGR</h3><br><br>
                  <div class="d-flex">
                    <div class="years-data">
                      <span *ngIf="item?.cagrYear[0]?.one"> 
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].one<0,  'data-green': item.cagrYear[0].one>=0}" > 
                          <ng-template [ngIf]="item.cagrYear[0].one === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].one !== 'NA'">
                            <span>{{item.cagrYear[0].one}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.one">-</span>
                      <br>
                        <span class="years-share-text"> (Last 1 Year)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;   <span *ngIf="item?.cagrYear[0]?.three">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].three === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].three !== 'NA'">
                            <span>{{item.cagrYear[0].three}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.three">-</span>
                      <br>
                      &nbsp;<span class="years-share-text"> (Last 3 Years)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;    <span *ngIf="item?.cagrYear[0]?.five">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].five === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].five !== 'NA'">
                            <span>{{item.cagrYear[0].five}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.five">-</span>
                      <br>
                      &nbsp; <span class="years-share-text"> (Last 5 Years)</span>
                    </div>
                </div>
                  <span class="seperator"></span>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <br>
                  <div class="align-h">
                    <div class="stretch">
                    <button type="button" (click)="investOnline()" class="common-submit-button-banner cursor-pointer" [id]="'invest-' + i" [attr.aria-labelledby]="'invest-' + i + ' fund-' + i">Invest Now</button>
                   </div>
                   <div>
                    <button type="button" id="invest-now" (click)="viewDetails(item.scheme, item)" class="common-submit-button-banner cursor-pointer btn-color-black margin-left-15" [id]="'explore-' + i" [attr.aria-labelledby]="'explore-' + i + ' fund-' + i">Explore</button>
                  </div>
                  </div>
                  <br><br>
                </div>
              </div>
            </ng-container>

            </div>
            <div class="no-fund text-center" *ngIf="equityCount<=0">No Funds Available</div>
          </div>
          <div *ngIf="activeTab==='debt'">
            <div class="col-lg-12 p-0 row">
              <ng-container  *ngFor="let item of fundsData;let i=index">
              <div class="col-lg-6 p-0  mobile-padding-top " *ngIf="item.fundType==='Debt'">
                <div class="col-lg-12 individual-funds">
                  <div class="top-right-corner"
                  [ngClass]="{'top-right-corner-l': item.risk.trim()==='Low', 'top-right-corner-mh': item.risk.trim()==='Moderate' || item.risk.trim()==='Moderately High'  || item.risk.trim()==='Moderately Low' || item.risk.trim()==='Low to Moderate','top-right-corner-m': item.risk.trim()==='High' || item.risk.trim()==='Very High'}">
                    <span class="risk-text">{{item.risk}} Risk</span>
                  </div>
                  <span class="fund-heading">{{item.fundType}}</span>
                  <span class="growth-section">  {{splitString(item.plan)}}</span>
                  <br>
                  <h2 class="fund-heading-2" [id]="'fund-' + i">{{item.scheme}}</h2><br>
                  <span class="fund-text">{{item.description}}</span><br>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <span class="fund-date" *ngIf="item.currentDate"> As on {{commonDataService.customDate(item.currentDate)}} </span><br>
                  <span class="fund-date" *ngIf="!item.currentDate"> NA </span><br>
                  <span class="date-text">NAV &nbsp; &#8377;  {{item.nav }}</span> &nbsp;
                   <!-- <img src="assets/icons/up_arrow.png" class="img-width" *ngIf="item.navPercent>=0">
                   <img src="assets/icons/down_arrow.png" class="img-width" *ngIf="item.navPercent<0"> -->
                   <img
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRdVkehRZhOHpHmOJvx_iTmS-1JUBFYSZVEc6d4tzG6bg&s"
                        class="img-width"
                        *ngIf="item.navPercent>=0"
                        [attr.alt]="'NAV increased by ' + (item.navPercent | number:'1.2-2') + ' percent'">

                        <img
                        src="assets/icons/down_arrow.png"
                        class="img-width"
                        *ngIf="item.navPercent<0"
                        [attr.alt]="'NAV decreased by ' + ((item.navPercent * -1) | number:'1.2-2') + ' percent'">

                  <span [ngClass]="{'date-vals': item.navPercent>=0,'date-vals-low': item.navPercent<0}">( {{item.navPercent | number : '1.2-2'}}% )</span>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <h3 class="caption-cag">CAGR</h3><br><br>
                  <div class="d-flex">
                    <div class="years-data">
                      <span *ngIf="item?.cagrYear[0]?.one"> 
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].one<0,  'data-green': item.cagrYear[0].one>=0}" > 
                          <ng-template [ngIf]="item.cagrYear[0].one === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].one !== 'NA'">
                            <span>{{item.cagrYear[0].one}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.one">-</span>
                      <br>
                        <span class="years-share-text"> (Last 1 Year)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;   <span *ngIf="item?.cagrYear[0]?.three">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].three === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].three !== 'NA'">
                            <span>{{item.cagrYear[0].three}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.three">-</span>
                      <br>
                      &nbsp;<span class="years-share-text"> (Last 3 Years)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;    <span *ngIf="item?.cagrYear[0]?.five">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].five === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].five !== 'NA'">
                            <span>{{item.cagrYear[0].five}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.five">-</span>
                      <br>
                      &nbsp; <span class="years-share-text"> (Last 5 Years)</span>
                    </div>
                </div>
                  <span class="seperator"></span>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <br>
                  <div class="align-h">
                    <div class="stretch">
                    <button type="button" (click)="investOnline()" class="common-submit-button-banner cursor-pointer" [id]="'invest-' + i" [attr.aria-labelledby]="'invest-' + i + ' fund-' + i">Invest Now</button>
                   </div>
                   <div>
                    <button type="button" id="invest-now" (click)="viewDetails(item.scheme, item)" class="common-submit-button-banner cursor-pointer btn-color-black margin-left-15" [id]="'explore-' + i" [attr.aria-labelledby]="'explore-' + i + ' fund-' + i">Explore</button>
                  </div>
                  </div>
                  <br><br>
                </div>
              </div>
            </ng-container>

            </div>
            <div class="no-fund text-center" *ngIf="debtCount<=0">No Funds Available</div>
          </div>
          <div *ngIf="activeTab==='hybrid'">
            <div class="col-lg-12 p-0 row">
              <ng-container  *ngFor="let item of fundsData;let i=index">
              <div class="col-lg-6 p-0  mobile-padding-top " *ngIf="item.fundType==='Hybrid'">
                <div class="col-lg-12 individual-funds">
                  <div class="top-right-corner"
                  [ngClass]="{'top-right-corner-l': item.risk.trim()==='Low', 'top-right-corner-mh': item.risk.trim()==='Moderate' || item.risk.trim()==='Moderately High'  || item.risk.trim()==='Moderately Low' || item.risk.trim()==='Low to Moderate','top-right-corner-m': item.risk.trim()==='High' || item.risk.trim()==='Very High'}">
                    <span class="risk-text">{{item.risk}} Risk</span>
                  </div>
                  <span class="fund-heading">{{item.fundType}}</span>
                  <span class="growth-section">  {{splitString(item.plan)}}</span>
                  <br>
                  <h2 class="fund-heading-2" [id]="'fund-' + i">{{item.scheme}}</h2><br>
                  <span class="fund-text">{{item.description}}</span><br>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <span class="fund-date" *ngIf="item.currentDate"> As on {{commonDataService.customDate(item.currentDate)}} </span><br>
                  <span class="fund-date" *ngIf="!item.currentDate"> NA </span><br>
                  <span class="date-text">NAV &nbsp; &#8377;  {{item.nav }}</span> &nbsp;
                   <!-- <img src="assets/icons/up_arrow.png" class="img-width" *ngIf="item.navPercent>=0">
                   <img src="assets/icons/down_arrow.png" class="img-width" *ngIf="item.navPercent<0"> -->
                   <img
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRdVkehRZhOHpHmOJvx_iTmS-1JUBFYSZVEc6d4tzG6bg&s"
                        class="img-width"
                        *ngIf="item.navPercent>=0"
                        [attr.alt]="'NAV increased by ' + (item.navPercent | number:'1.2-2') + ' percent'">

                        <img
                        src="assets/icons/down_arrow.png"
                        class="img-width"
                        *ngIf="item.navPercent<0"
                        [attr.alt]="'NAV decreased by ' + ((item.navPercent * -1) | number:'1.2-2') + ' percent'">

                  <span [ngClass]="{'date-vals': item.navPercent>=0,'date-vals-low': item.navPercent<0}">( {{item.navPercent | number : '1.2-2'}}% )</span>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <h3 class="caption-cag">CAGR</h3><br><br>
                  <div class="d-flex">
                    <div class="years-data">
                      <span *ngIf="item?.cagrYear[0]?.one"> 
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].one<0,  'data-green': item.cagrYear[0].one>=0}" > 
                          <ng-template [ngIf]="item.cagrYear[0].one === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].one !== 'NA'">
                            <span>{{item.cagrYear[0].one}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.one">-</span>
                      <br>
                        <span class="years-share-text"> (Last 1 Year)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;   <span *ngIf="item?.cagrYear[0]?.three">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].three === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].three !== 'NA'">
                            <span>{{item.cagrYear[0].three}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.three">-</span>
                      <br>
                      &nbsp;<span class="years-share-text"> (Last 3 Years)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;    <span *ngIf="item?.cagrYear[0]?.five">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          <ng-template [ngIf]="item.cagrYear[0].five === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].five !== 'NA'">
                            <span>{{item.cagrYear[0].five}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.five">-</span>
                      <br>
                      &nbsp; <span class="years-share-text"> (Last 5 Years)</span>
                    </div>
                </div>
                  <span class="seperator"></span>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <br>
                  <div class="align-h">
                    <div class="stretch">
                    <button type="button" (click)="investOnline()" class="common-submit-button-banner cursor-pointer" [id]="'invest-' + i" [attr.aria-labelledby]="'invest-' + i + ' fund-' + i">Invest Now</button>
                   </div>
                   <div>
                    <button type="button" id="invest-now" (click)="viewDetails(item.scheme, item)" class="common-submit-button-banner cursor-pointer btn-color-black margin-left-15" [id]="'explore-' + i" [attr.aria-labelledby]="'explore-' + i + ' fund-' + i">Explore</button>
                  </div>
                  </div>
                  <br><br>
                </div>
              </div>
            </ng-container>

            </div>
            <div class="no-fund text-center" *ngIf="hyBridCount<=0">No Funds Available</div>
          </div>
          <div *ngIf="activeTab==='other'">
            <div class="col-lg-12 p-0 row">
              <ng-container  *ngFor="let item of fundsData;let i=index">
              <div class="col-lg-6 p-0 mobile-padding-top " *ngIf="item.fundType!=='Equity' && item.fundType!=='Debt' && item.fundType!=='Hybrid' ">
                <div class="col-lg-12 individual-funds">
                  <div class="top-right-corner"
                  [ngClass]="{'top-right-corner-l': item.risk.trim()==='Low', 'top-right-corner-mh': item.risk.trim()==='Moderate' || item.risk.trim()==='Moderately High'  || item.risk.trim()==='Moderately Low' || item.risk.trim()==='Low to Moderate','top-right-corner-m': item.risk.trim()==='High' || item.risk.trim()==='Very High'}">
                    <span class="risk-text">{{item.risk}} Risk</span>
                  </div>
                  <span class="fund-heading">{{item.fundType}}</span>
                  <span class="growth-section">  {{splitString(item.plan)}}</span>
                  <br>
                  <h2 class="fund-heading-2" [id]="'fund-' + i">{{item.scheme}}</h2><br>
                  <span class="fund-text">{{item.description}}</span><br>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <span class="fund-date" *ngIf="item.currentDate"> As on {{commonDataService.customDate(item.currentDate)}}</span><br>
                  <span class="fund-date" *ngIf="!item.currentDate"> NA </span><br>
                  <span class="date-text">Nav &nbsp; &#8377;  {{item.nav }}</span> &nbsp;
                  <!-- <img src="assets/icons/up_arrow.png" class="img-width" *ngIf="item.navPercent>=0">
                  <img src="assets/icons/down_arrow.png" class="img-width"  *ngIf="item.navPercent<0"> -->
                  <img
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRdVkehRZhOHpHmOJvx_iTmS-1JUBFYSZVEc6d4tzG6bg&s"
                      class="img-width"
                      *ngIf="item.navPercent>=0"
                      [attr.alt]="'NAV increased by ' + (item.navPercent | number:'1.2-2') + ' percent'">

                      <img
                      src="assets/icons/down_arrow.png"
                      class="img-width"
                      *ngIf="item.navPercent<0"
                      [attr.alt]="'NAV decreased by ' + ((item.navPercent * -1) | number:'1.2-2') + ' percent'">

                  <span [ngClass]="{'date-vals': item.navPercent>=0,'date-vals-low': item.navPercent<0}">( {{item.navPercent | number : '1.2-2'}}% )</span>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <h3 class="caption-cag">CAGR</h3><br><br>
                  <div class="d-flex">
                    <div class="years-data">
                      <span *ngIf="item?.cagrYear[0]?.one"> 
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].one<0,  'data-green': item.cagrYear[0].one>=0}" > 
                          <ng-template [ngIf]="item.cagrYear[0].one === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].one !== 'NA'">
                            <span>{{item.cagrYear[0].one}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.one">-</span>
                      <br>
                        <span class="years-share-text"> (Last 1 Year)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;   <span *ngIf="item?.cagrYear[0]?.three">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}">
                           <ng-template [ngIf]="item.cagrYear[0].three === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].three !== 'NA'">
                            <span>{{item.cagrYear[0].three}}%</span>
                          </ng-template>
                          </span>
                        </span>
                      <span *ngIf="!item?.cagrYear[0]?.three">-</span>
                      <br>
                      &nbsp;<span class="years-share-text"> (Last 3 Years)</span>
                    </div>
                    <div class="years-data">
                      &nbsp;    <span *ngIf="item?.cagrYear[0]?.five">
                        <span class="years-share-val " [ngClass]="{'data-red': item.cagrYear[0].three<0,  'data-green': item.cagrYear[0].three>=0}"> 
                          {{item.cagrYear[0].five}}%
                          <ng-template [ngIf]="item.cagrYear[0].five === 'NA'">
                            <span>NA</span>
                          </ng-template>
                          <ng-template [ngIf]="item.cagrYear[0].five !== 'NA'">
                            <span>{{item.cagrYear[0].five}}%</span>
                          </ng-template>
                        </span>
                      </span>
                      <span *ngIf="!item?.cagrYear[0]?.five">-</span>
                      <br>
                      &nbsp; <span class="years-share-text"> (Last 5 Years)</span>
                    </div>
                </div>
                  <span class="seperator"></span>
                  <hr class="hr-line" role="presentation" aria-hidden="true">
                  <br>
                  <div class="align-h">
                    <div class="stretch">
                    <button type="button" (click)="investOnline()" class="common-submit-button-banner cursor-pointer" [id]="'invest-' + i" [attr.aria-labelledby]="'invest-' + i + ' fund-' + i">Invest Now</button>
                   </div>
                   <div>
                    <button type="button" id="invest-now" (click)="viewDetails(item.scheme, item)" class="common-submit-button-banner cursor-pointer btn-color-black margin-left-15" [id]="'explore-' + i" [attr.aria-labelledby]="'explore-' + i + ' fund-' + i">Explore</button>
                  </div>
                  </div>
                  <br><br>
                </div>
              </div>
            </ng-container>

            </div>
            <div class="no-fund text-center" *ngIf="otherCount<=0">No Funds Available</div>
          </div>
        </div>
      <!-- </div> -->
    </div>
  </div>
</div>

